import { cfg } from '../../config';
import dotenv from 'dotenv';

dotenv.config();

export async function createUserData(userId) {
  try {
    const response = await fetch(`${process.env.HOST}/${cfg.API.routes.user}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId,
      }),
    });
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, data: error };
  }
}
